import { FinalFormatterMiddleware, TolgeePlugin } from '@tolgee/react';

function createFormatNoBrain(): FinalFormatterMiddleware {
    return {
        format: ({ translation }) => translation,
    };
}

export const FormatNoBrain = (): TolgeePlugin => (tolgee, tools) => {
    tools.setFinalFormatter(createFormatNoBrain());
    return tolgee;
};
